module.exports = __webpack_public_path__ + "img/en-box4-text-light.6f01ed82.png";